import React from "react";
import { Routes, Route } from "react-router-dom";
// import HeaderRanking from "../Components/Ranking/headerRanking";
// import ListBuilderRating from "../Components/Ranking/listBuilderRanking";
import ListProjectRating from "../Components/Resale Ranking/listProjectRanking";
// import ListProjectVideoRating from "../Components/Ranking/listVideoRanking";

const RankingResaleRoutes = () => {
  return (
    <Routes>
      {/* <Route path="/ranking" element={<HeaderRanking></HeaderRanking>}></Route> */}
      {/* <Route path="/ranking_builder_list" element={<ListBuilderRating></ListBuilderRating>}></Route> */}
      <Route path="/resale_ranking" element={<ListProjectRating></ListProjectRating>}></Route>
      {/* <Route path="/ranking_video_list" element={<ListProjectVideoRating></ListProjectVideoRating>}></Route> */}
    </Routes>
  );
};

export default RankingResaleRoutes;
